import { WireCompanyAccountModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';

const defaultDto: WireCompanyAccountModelDto = {
    id: 0,
    cifNumber: '',
    number: '',
    isAccountActive: false,
    accountUniqueId: '',
};

export class WireCompanyAccount extends DomainEntity<WireCompanyAccountModelDto> {
    constructor(dto = defaultDto) {
        super(dto);
    }

    public createDefault(): this {
        return new WireCompanyAccount() as this;
    }

    public get id() {
        return this.dto.id;
    }

    public get cifNumber() {
        return this.dto.cifNumber;
    }

    public get transactionLimit() {
        return this.dto.transactionLimit;
    }

    public get dailyLimit() {
        return this.dto.dailyLimit;
    }

    public get isSelected() {
        return this.dto.isSelected ?? false;
    }

    public set isSelected(value: boolean) {
        this.dto.isSelected = value;
    }

    public get isEnabled() {
        return this.dto.isEnabled ?? false;
    }

    public set isEnabled(value: boolean) {
        this.dto.isEnabled = value;
    }

    public get isDisabled() {
        return this.dto.isDisabled ?? false;
    }

    public set isDisabled(value: boolean) {
        this.dto.isDisabled = value;
    }

    public get number() {
        return this.dto.number;
    }

    public get name() {
        return this.dto.name;
    }

    public get isCompanyAccount() {
        return this.dto.isCompanyAccount;
    }
}
